import { Todo, TaskStatus } from '../../types';

interface FilterOptions {
  searchQuery: string;
  statusFilter: TaskStatus[];
  horizonFilter: string[];
  tagsFilter: string[];
  taskTypeFilter: 'all' | 'parent_only' | 'child_only';
}

export function filterTodos(todos: Todo[], filters: FilterOptions): Todo[] {
  // Pre-compute set of IDs that are parents (have at least one child)
  const parentIds = filters.taskTypeFilter === 'parent_only'
    ? new Set(todos.map(t => t.parent_id).filter(Boolean))
    : null;

  return todos.filter(todo => {
    // Search filter
    if (filters.searchQuery) {
      const searchLower = filters.searchQuery.toLowerCase();
      const matchesSearch = 
        todo.title.toLowerCase().includes(searchLower) ||
        (todo.description && todo.description.toLowerCase().includes(searchLower));
      if (!matchesSearch) return false;
    }

    // Status filter
    if (filters.statusFilter.length > 0) {
      if (!filters.statusFilter.includes(todo.status)) return false;
    }

    // Horizon filter
    if (filters.horizonFilter && filters.horizonFilter.length > 0) {
      if (!filters.horizonFilter.includes(todo.horizon || '')) return false;
    }

    // Tags filter
    if (filters.tagsFilter.length > 0) {
      const hasMatchingTag = filters.tagsFilter.some(tag => 
        todo.tags.includes(tag)
      );
      if (!hasMatchingTag) return false;
    }

    // Task type filter
    if (filters.taskTypeFilter === 'parent_only') {
      if (!parentIds!.has(todo.id)) return false;
    } else if (filters.taskTypeFilter === 'child_only') {
      if (!todo.parent_id) return false;
    }

    return true;
  });
}